import $ from 'jquery';
import moment from 'moment-timezone';

function Api() {
}

Api.prototype.urlApi = process.env.VUE_APP_ROOT_API_PLATAFORMA;

Api.prototype.getHash = function () {
    return JSON.parse(localStorage.getItem('dsHash'));
}

Api.prototype.getTokenEventos = function () {
    let $this = this;

    var dshash = JSON.parse(localStorage.getItem('dsHash'));
    var user = JSON.parse(localStorage.getItem('user_eventos'));

    var expire;
    if (user === null || user === '') {
        expire = new Date('01/01/2000');
    } else {
        expire = new Date(user.expiration);
    }

    moment.tz.setDefault('America/Sao_Paulo');
    var date_moment = moment();
    var todaysDate = date_moment.toDate();

    if (todaysDate > expire) {
        $.ajax({
            url: process.env.VUE_APP_ROOT_EVENTOS_API + '/auth/signin?dsHash=' + dshash,
            type: "POST",
            data: {},
            dataType: 'json',
            contentType: 'application/json',
            async: false,
            success: function (response) {
                localStorage.removeItem('user_eventos');
                localStorage.setItem('user_eventos', JSON.stringify(response.bearerToken));
                user = JSON.parse(localStorage.getItem('user_eventos'));
            },
            error: function (result) {
                localStorage.removeItem('user_eventos');
                /*window.location = '/permissao';*/
            }
        });
    }
    return { Authorization: 'Bearer ' + user.accessToken };
}

Api.prototype.getTokenPlataforma = function () {
    let $this = this;

    var dshash = JSON.parse(localStorage.getItem('dsHash'));

    var user = JSON.parse(localStorage.getItem('user_plataforma'));
    var expire;

    if (user === null || user === '') {
        expire = new Date('01/01/2000');
    } else {
        expire = new Date(user.expiration);
    }

    moment.tz.setDefault('America/Sao_Paulo');
    var date_moment = moment();
    var todaysDate = date_moment.toDate();

    if (todaysDate > expire) {
        $.ajax({
            url: process.env.VUE_APP_ROOT_API_PLATAFORMA + '/auth/signin?dsHash=' + dshash,
            type: "POST",
            data: {},
            dataType: 'json',
            contentType: 'application/json',
            async: false,
            success: function (response) {
                localStorage.removeItem('user_plataforma');
                localStorage.setItem('user_plataforma', JSON.stringify(response.bearerToken));
                user = JSON.parse(localStorage.getItem('user_plataforma'));
            },
            error: function (result) {
                localStorage.removeItem('dsHash');
                localStorage.removeItem('user_plataforma');
                window.location = '/';
            }
        });
    }
    return { Authorization: 'Bearer ' + user.accessToken };
}

Api.prototype.getTokenComercial = function () {
    let $this = this;

    var dshash = JSON.parse(localStorage.getItem('dsHash'));
    var user = JSON.parse(localStorage.getItem('user_comercial'));

    var expire;
    if (user === null || user === '') {
        expire = new Date('01/01/2000');
    } else {
        expire = new Date(user.expiration);
    }

    var todaysDate = new Date();

    if (todaysDate > expire) {
        $.ajax({
            url: process.env.VUE_APP_ROOT_COMERCIAL_API + '/auth/signin?dsHash=' + dshash,
            type: "POST",
            data: {},
            dataType: 'json',
            contentType: 'application/json',
            async: false,
            success: function (response) {
                localStorage.removeItem('user_comercial');
                localStorage.setItem('user_comercial', JSON.stringify(response.bearerToken));
                user = JSON.parse(localStorage.getItem('user_comercial'));
            },
            error: function (result) {
                localStorage.removeItem('user_comercial');
                window.location = '/';
            }
        });
    }
    return { Authorization: 'Bearer ' + user.accessToken };
}

Api.prototype.install = function (app) {
    app.api = this;
    app.config.globalProperties.$api = this;
}

export function Api_Plugin() {
    return new Api();
}